import * as R from 'ramda';
import styled  from 'styled-components';

import { DisplayFlexS } from '../../../utils/stylesHelpers';
import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';
import { PrimaryButtonS, Rating, Text, TextArea } from '../common';
import { BaseBlockStyled, BaseBlockHeaderS, GoBackBtnWrapS } from '../company/companyItemS';

export const GoBackBtnWrapResponsiveS = styled(GoBackBtnWrapS) `
  @media (max-width: ${getScreenSize(['medium'])}) {
      padding-left: 22px;
      padding-right: 22px;
      padding-bottom: 7px;
  }
`;

export const GoBackBtnTextS = styled(Text)`
  font-size: 18px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-size: ${getThemeSize(['mediumText'])};
  }
`;

export const GoBackBtnIconS = styled(Text)`
  font-size: 18px;
  margin-right: 15px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-size: ${getThemeSize(['normalText'])};
    margin-right: 5px;
  }
`;

export const BaseBlockStyledResponsive = styled(BaseBlockStyled)`
  @media (max-width: ${getScreenSize(['medium'])}) {
      margin-left: 24px;
      margin-right: 24px;
  }
`;

export const DisplayFlexResponsiveS = styled(DisplayFlexS)`
  padding: 20px 24px;
  @media (max-width: ${getScreenSize(['medium'])}) {
      flex-direction: column;
  }
`;

export const DisplayFlexRatingS = styled(DisplayFlexS)`

  @media (max-width: ${getScreenSize(['medium'])}) {
      flex-direction: column;
      margin-top: 0 !important;
      margin-bottom: 18px !important;

      font-size: ${getThemeSize(['mediumText'])};
  }
`;

export const AvatarWrapperS = styled.div`
  display: none;

  @media (max-width: ${getScreenSize(['medium'])}){
    display: flex;
    width: 100%;
    gap: 12px;
    align-items: center;

    padding: 12px;
    border-bottom: 1px solid ${getThemeColor(['grayBlue'])};
  }
`;

export const AvatarS = styled.div`
  display: none;
  
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 63px;
    height: 63px;
    border: 1px solid ${getThemeColor(['grayBlue'])};
    border-radius: 50%;

    ${({ isLoggedIn }) =>
      isLoggedIn ?
        `img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 50%;
        }` : 
        `img {
          width: 26px;
          height: 23px;
        }`
      }

    img[data-logo="false"] {
      width: 58%;
      height: auto;
      border-radius: 0;
    }
  }
`;

export const InfoBlockHeaderS = styled.p`
  flex-basis: 25%;
  flex-grow: 0;
  flex-shrink: 0;
  
  font-size: ${getThemeSize(['bigText'])};
  font-family: ${getThemeFont(['bold'])};
  color: ${getThemeColor(['violet'])};
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 11px 14px 14px;
    font-size: 15px;
  }
`;

export const CreateCommentsBlockHeaderS = styled(BaseBlockHeaderS)`
  padding: 20px;
  color: ${getThemeColor(['violet'])};
  font-size: ${getThemeSize(['bigText'])};
  font-family: ${getThemeFont(['bold'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0 !important;
    padding: 20px 12px 12px;
    background-color: ${getThemeColor(['grayBlue'])};
    font-size: ${getThemeSize(['mediumText'])};
    border-radius: 3px;
  }
`;

export const FormS = styled.form`

  @media (max-width: ${getScreenSize(['medium'])}) {
    padding: 0 14px;
  }
`;

export const RatingTextS = styled(Text)`

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
  }
`;

export const RatingS = styled(Rating)`

  @media (max-width: ${getScreenSize(['medium'])}) {
    span:nth-child(2) {
      font-size:  ${getThemeSize(['mediumText'])} !important;
      color: rgba(77, 77, 77, 0.41) !important;
    }

    img {
      margin-right: 8px;
      width: 18px;
    }
  }
`;

export const InputWrapS = styled.div`
  flex-basis: ${R.propOr('100%', 'width')};
  margin-bottom: 10px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 10px;
    flex-basis: ${R.propOr('100%', 'mobileWidth')};
    width: 100%;
  }
`;

export const TextAreaS = styled(TextArea)`
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    height: 100px;
  }
`;

export const DisplayFlexButtonS = styled(DisplayFlexS)`
  margin-top: 20px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-top: 24px;
    margin-bottom: 36px;
  }
`;

export const ButtonS = styled(PrimaryButtonS)`
  @media (max-width: ${getScreenSize(['medium'])}) {
    padding: 10px 12px;
    font-weight: bold;
  }
`;